<!-- cv简历信息表-爱好与特长-组件级 -->
<template>
  <div class='detail-wrap-course'>
    <div class='detail-container'>
      <div class='cv-detail cn'
           v-if='!isEditCn && lang==="cn"'>
        <h4>若你是高三在读生，请填写以下信息：</h4>
        <p class='warning pad-top'>以下提供的中英文课程名称必须要和学校的官方成绩单一致</p>
        <ul>
          <li>
            <span class='cv-detail-name'>高三上学期课程：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.seniorThree1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>高三下学期课程：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.seniorThree2)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>大学课程/网络课程：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.onlineCourses)'></span>
          </li>
        </ul>
        <h4 class='pad-top'>若你是大学在读生，请填写以下信息：</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>大一上学期课程和学分：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.freshman1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>大一下学期课程和学分：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.freshman2)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>大二上学期课程和学分（如有）：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.sophomore1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>大二下学期课程和学分（如有）：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailCn.sophomore2)'></span>
          </li>
        </ul>
      </div>
      <div class='cv-detail en'
           v-if='!isEditEn && lang==="en"'>
        <h4>Please specify the following information if the student is currently a senior in high school.</h4>
        <p class='warning pad-top'>(all information must agree with the official transcript)</p>
        <ul>
          <li>
            <span class='cv-detail-name'>Courses taken during the first semester of grade 12：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.seniorThree1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Courses taken during the second semester of grade 12：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.seniorThree2)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>If has taken online courses, please list them here (Coursera, edX, etc..)：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.onlineCourses)'></span>
          </li>
        </ul>
        <h4 class='pad-top'>Please specify the following information if the student is currently studying in college</h4>
        <ul>
          <li>
            <span class='cv-detail-name'>Classes taken in the first semester of freshman year and GPA received：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.freshman1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Classes taken in the second semester of freshman year and GPA received：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.freshman2)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Classes taken in the first semester as a sophomore and GPA received (if applicable)：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.sophomore1)'></span>
          </li>
          <li>
            <span class='cv-detail-name'>Classes taken in the second semester as a sophomore and GPA received (if applicable)：</span>
            <span class='cv-detail-val'
                  v-html='lineFilter(courseDetailEn.sophomore2)'></span>
          </li>
        </ul>
      </div>
      <div class='cv-form cn'
           v-if='isEditCn && lang==="cn"'>
        <Form ref="formValidateCn"
              :model="formValidateCn"
              :rules="ruleValidateCn"
              label-position='top'>

          <div class="base-form-item">
            <h4 class='no-pad'
                style='padding-top: 20px'>若你是高三在读生，请填写以下信息：</h4>
            <p class='warning no-pad pad-top pad-btm'>以下提供的中英文课程名称必须要和学校的官方成绩单一致</p>
            <FormItem label="高三上学期课程："
                      prop="seniorThree1">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.seniorThree1"
                     placeholder="请列出课程的中英文名称，每行一个"></Input>
            </FormItem>
            <FormItem label="高三下学期课程："
                      prop="seniorThree2">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.seniorThree2"
                     placeholder="请列出课程的中英文名称，每行一个"></Input>
            </FormItem>
            <FormItem label="大学课程/网络课程："
                      prop="onlineCourses">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.onlineCourses"
                     placeholder="若学习过大学课程/网络课程的， 请在此填写（例如Coursera，edX等） "></Input>
            </FormItem>
            <h4 class='no-pad pad-top pad-btm'>若你是大学在读生，请填写以下信息：</h4>
            <FormItem label="大一上学期课程和学分："
                      prop="freshman1">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.freshman1"
                     placeholder="请列出课程和学分，每行一个，如高等数学，6学分"></Input>
            </FormItem>
            <FormItem label="大一下学期课程和学分："
                      prop="freshman2">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.freshman2"
                     placeholder="请列出课程和学分，每行一个，如高等数学，6学分"></Input>
            </FormItem>
            <FormItem label="大二上学期课程和学分（如有）："
                      prop="sophomore1">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.sophomore1"
                     placeholder="请列出课程和学分，每行一个，如高等数学，6学分"></Input>
            </FormItem>
            <FormItem label="大二下学期课程和学分（如有）："
                      prop="sophomore2">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateCn.sophomore2"
                     placeholder="请列出课程和学分，每行一个，如高等数学，6学分"></Input>
            </FormItem>
          </div>

          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveCn'
                    @click="saveCn">保存</Button>
            <!-- <a href='javascript: void(0)'
               @click="saveCn">保存</a> -->
          </div>
        </Form>
      </div>
      <div class='cv-form en'
           v-if='isEditEn && lang==="en"'>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              label-position='top'>

          <div class="base-form-item">
            <h4 class='no-pad'
                style='padding-top: 20px'>Please specify the following information if the student is currently a senior in high school.</h4>
            <p class='warning no-pad pad-top pad-btm'>(all information must agree with the official transcript)</p>
            <FormItem label="Courses taken during the first semester of grade 12："
                      prop="seniorThree1">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.seniorThree1"
                     placeholder="please list out all classes taken in Chinese and English"></Input>
            </FormItem>
            <FormItem label="Courses taken during the second semester of grade 12："
                      prop="seniorThree2">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.seniorThree2"
                     placeholder="please list out all classes taken in Chinese and English"></Input>
            </FormItem>
            <FormItem label="If has taken online courses, please list them here (Coursera, edX, etc..)："
                      prop="onlineCourses">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.onlineCourses"
                     placeholder="please list out all classes taken in Chinese and English "></Input>
            </FormItem>
            <h4 class='no-pad pad-top pad-btm'>Please specify the following information if the student is currently studying in college</h4>
            <FormItem label="Classes taken in the first semester of freshman year and GPA received："
                      prop="freshman1">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.freshman1"
                     placeholder="please list course and credit received, start a new line for each different course "></Input>
            </FormItem>
            <FormItem label="Classes taken in the second semester of freshman year and GPA received："
                      prop="freshman2">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.freshman2"
                     placeholder="please list course and credit received, start a new line for each different course "></Input>
            </FormItem>
            <FormItem label="Classes taken in the first semester as a sophomore and GPA received (if applicable)："
                      prop="sophomore1">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.sophomore1"
                     placeholder="please list course and credit received, start a new line for each different course "></Input>
            </FormItem>
            <FormItem label="Classes taken in the second semester as a sophomore and GPA received (if applicable)："
                      prop="sophomore2">
              <Input type='textarea'
                     :rows="5"
                     v-model="formValidateEn.sophomore2"
                     placeholder="please list course and credit received, start a new line for each different course "></Input>
            </FormItem>
          </div>
          <div class="sub-btn">
            <Button type='primary'
                    :loading='hasSaveEn'
                    @click="saveEn">Save</Button>
            <!-- <a href='javascript: void(0)'
               @click="saveEn">Save</a> -->
          </div>
        </Form>
      </div>
      <div class='cv-btn cn'
           v-if='lang==="cn"'>
        <a href='javascript: void(0)'
           @click="goEditCn">{{isEditCn ? '返回' : '编辑'}}</a>
      </div>
      <div class='cv-btn en'
           v-if='lang==="en"'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import cvService from '@/api/undergraduate/cv'
import { proficiencyCnMap, proficiencyEnMap, proTrainingCnMap, proTrainingEnMap } from '../constants'
export default {
  name: '',
  props: {
    lang: {
      type: String,
      default: ''
    }
  },
  components: {},
  data () {
    return {
      // 熟练程度映射
      proficiencyCnMap,
      proficiencyEnMap,
      // 是否专业训练映射
      proTrainingCnMap,
      proTrainingEnMap,
      // 是否编辑状态标识
      isEditEn: false,
      isEditCn: false,
      // 课程信息详情
      courseDetailCn: {},
      courseDetailEn: {},
      // Cn表单
      formValidateCn: {
        seniorThree1: '',
        seniorThree2: '',
        onlineCourses: '',
        freshman1: '',
        freshman2: '',
        sophomore1: '',
        sophomore2: ''
      },
      ruleValidateCn: {},
      // En表单
      formValidateEn: {
        seniorThree1: '',
        seniorThree2: '',
        onlineCourses: '',
        freshman1: '',
        freshman2: '',
        sophomore1: '',
        sophomore2: ''
      },
      ruleValidateEn: {},
      // loading-表单提交-避免重复提交
      hasSaveCn: false,
      hasSaveEn: false
    }
  },
  computed: {},
  mounted () {
    this.$nextTick(() => {
      if (this.lang === 'cn') {
        this.getCourseDetailCn()
      }
      if (this.lang === 'en') {
        this.getCourseDetailEn()
      }
    })
  },
  methods: {
    // 换行过滤
    lineFilter (value) {
      if (value) {
        let result = value
        for (let i = 0; i < result.length; i++) {
          result = result.replace(/\n/g, '<br/>').replace(/\r/g, '<br/>')
        }
        return result
      }
    },
    // 获取课程信息-cn
    getCourseDetailCn () {
      cvService.cvCourseDetailCn().then(res => {
        if (res.data.model) {
          this.courseDetailCn = res.data.model
          this.formValidateCn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 获取课程信息-en
    getCourseDetailEn () {
      cvService.cvCourseDetailEn().then(res => {
        if (res.data.model) {
          this.courseDetailEn = res.data.model
          this.formValidateEn = res.data.model
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },
    // 编辑-返回
    goEditCn () {
      this.isEditCn = !this.isEditCn
      this.getCourseDetailCn()
    },
    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getCourseDetailEn()
    },
    // 保存
    saveCn () {
      this.$refs.formValidateCn.validate((valid) => {
        if (valid) {
          this.hasSaveCn = true
          // 调用接口
          cvService.cvSaveCourseCn(this.formValidateCn).then(res => {
            this.hasSaveCn = false
            this.isEditCn = false
            this.$ugd_message('保存成功', 'success')
            this.getCourseDetailCn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveCn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    },
    // Save
    saveEn () {
      this.$refs.formValidateEn.validate((valid) => {
        if (valid) {
          this.hasSaveEn = true
          // 调用接口
          cvService.cvSaveCourseEn(this.formValidateEn).then(res => {
            this.hasSaveEn = false
            this.isEditEn = false
            this.$ugd_message('Save Success', 'success')
            this.getCourseDetailEn()
            // 调用详情接口
          }).catch(error => {
            this.hasSaveEn = false
            this.$ugd_message(error.message, 'error')
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.detail-wrap-course {
  padding-top: 10px;
  .detail-container {
    background: #fff;
    padding: 10px;
    display: flex;
    .cv-detail {
      flex: 1;
      padding: 20px 0;
      li {
        font-size: 14px;
        color: #667483;
        letter-spacing: 0;
        line-height: 30px;
        padding: 10px 0 10px 60px;
        word-break: break-all;
        .cv-detail-name {
          display: block;
        }
        .cv-detail-val {
          display: block;
        }
      }
    }
    .cv-form {
      flex: 1;
      padding: 20px 0 20px 60px;
    }
    .cv-btn {
      flex: 0 0 160px;
      text-align: right;
      a {
        display: inline-block;
        width: 96px;
        height: 32px;
        background: rgb(224, 235, 254);
        border-radius: 8px;
        border-radius: 8px;
        font-size: 14px;
        color: #186ffa;
        letter-spacing: 0;
        text-align: center;
        line-height: 32px;
        margin-left: 10px;
      }
    }
  }
  h4 {
    font-size: 18px;
    color: #4aa6ff;
    letter-spacing: 0;
    padding-left: 60px;
  }
  .sub-btn {
    text-align: right;
    button {
      display: inline-block;
      width: 100px;
      height: 36px;
      background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
      border-radius: 8px;
      border-radius: 8px;
      font-size: 18px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
    }
  }
  .warning {
    font-size: 14px;
    color: #ff6020;
    letter-spacing: 0;
    padding-left: 60px;
  }
  h4.no-pad,
  p.no-pad {
    padding-left: 0;
  }
  .pad-top {
    padding-top: 20px;
  }
  .pad-btm {
    padding-bottom: 20px;
  }
}
</style>
